import { useTranslation } from 'react-i18next';
import type { Locale } from '../api/types';
import { currentLocale, LOCALE_NATIVE_NAMES, setAppLanguage, SUPPORTED_LOCALES } from '../i18n';

/** Review fix F11: choose the interface language before signing in. Options are labeled in their
 * own language and script. Signed-in users change language in Settings instead (that also updates
 * the content language stored on their profile). */
export function LanguagePicker({ id }: { id: string }) {
  const { t } = useTranslation();
  const value = currentLocale();
  return (
    <div className="language-picker">
      <label htmlFor={id}>{t('a11y.language')}</label>
      <select id={id} value={value} onChange={(e) => setAppLanguage(e.target.value as Locale)}>
        {SUPPORTED_LOCALES.map((locale) => (
          <option key={locale} value={locale} lang={locale}>
            {LOCALE_NATIVE_NAMES[locale]}
          </option>
        ))}
      </select>
    </div>
  );
}
